import React, { useContext } from 'react';
import './style.css';
import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Logout } from '@mui/icons-material';
import { Box } from '@mui/system';
import firebase from 'firebase/app';
import 'firebase/auth';
import { useUser } from 'reactfire';
import clearFirestoreCache from '../../../common/clearFirestoreCache';
import fullnameInitials from '../../../lib/stringСonversion';
import { UIContext } from '../UIContext';

const AppBar: React.FC = () => {
  const { data: user } = useUser();
  const { setAlert } = useContext(UIContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  async function logOut() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        setAlert({
          show: true,
          severity: 'success',
          message: 'you have successfully logged out',
        });
        clearFirestoreCache();
      })
      .catch((error) => {
        const errorMessage =
          error instanceof Error ? error.message : 'Something went wrong';
        setAlert({
          show: true,
          severity: 'error',
          message: errorMessage,
        });
      });
  }
  return (
    <Box className="AppBar">
      <Box className="home-burger-container">
        <MenuIcon
          className="burger-menu"
          sx={{ color: 'white', fontSize: '20px' }}
        />
        <Typography variant="h5" className="home-title">
          Voypost
        </Typography>
      </Box>
      <Box textAlign="center" display="flex" alignItems="center">
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>
              {fullnameInitials(user.displayName)}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.3,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={logOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default AppBar;
